<template>
  <div class="mb-6">
    <div class="columns is-multiline">
      <div class="column is-12-mobile is-2-tablet">
        <InputText :hasIconSearch="true" name="Produttore" v-model="filters.brand" @input="onFilterInput" />
      </div>
      <div class="column is-12-mobile is-2-tablet">
        <InputText :hasIconSearch="true" name="Codice" v-model="filters.code" @input="onFilterInput" />
      </div>
      <div class="column is-12-mobile is-2-tablet">
        <InputText :hasIconSearch="true" name="Descrizione" v-model="filters.name" @input="onFilterInput" />
      </div>
      <div class="column is-12-mobile is-2-tablet">
        <InputText :hasIconSearch="true" name="Note" v-model="filters.notes" @input="onFilterInput" />
      </div>
      <div class="column is-12-mobile is-2-tablet">
        <InputSelect
          name="Archiviato"
          v-model="filters.archived"
          @select="onFilterInput"
          :options="[{'label': 'Sì', value: true}, {'label': 'No', value: false}]"
          id="value"
          track-by="value"
          label="label"
          :allowEmpty="false"
        />
      </div>
      <div class="column is-12-mobile is-4-tablet">
        <label class="label">&nbsp;</label>
        <div class="buttons is-flex">
          <button class="button" @click="resetFilters()"><font-awesome-icon icon="filter-circle-xmark" />Reset</button>
          <router-link to="/magazzino/new" class="button is-primary is-hidden-touch" @click="resetFilters()"><font-awesome-icon icon="plus" />Aggiungi</router-link>
        </div>
      </div>
    </div>

    <div class="b-table has-pagination" :class="{'is-loading': loading}">
      <div class="table-wrapper has-mobile-cards">
        <table class="table is-fullwidth is-striped is-hoverable">
          <thead>
            <tr>
              <th style="width: 24px;" v-if="isSelection"></th>
              <th>Produttore</th>
              <th>Codice</th>
              <th>Descrizione</th>
              <th>Unità</th>
              <th>Iva</th>
              <th>Ultimo prezzo vendita</th>
              <th>Note</th>
              <th>Disponibili</th>
              <th>Ordinati</th>
              <th>Usati</th>
              <th style="min-width: 100px;"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(product, index) in products" :key="index">
              <td v-if="isSelection">
                <label class="radio">
                  <input type="radio" :value="product" v-model="selectedProduct" @change="() => $emit('selected', selectedProduct)">
                </label>
              </td>
              <td data-label="Produttore">
                {{product.brand}}
              </td>
              <td data-label="Codice">
                {{product.code}}
              </td>
              <td data-label="Descrizione">
                {{product.name}}
              </td>
              <td data-label="Unità">
                {{product.unit}}
              </td>
              <td data-label="Iva">
                {{product.vat}}
              </td>
              <td data-label="Ultimo prezzo vendita">
                <div v-if="product.lastSalePrice && !product.lastSaleDiscount">
                  € {{preparePrice(product.lastSalePrice).toFixed(2)}}
                </div>
                <div v-if="product.lastSalePrice && product.lastSaleDiscount" class="has-text-grey is-abbr-like" style="text-decoration: line-through;">
                  € {{preparePrice(product.lastSalePrice).toFixed(2)}}
                </div>
                <div v-if="product.lastSaleDiscount">
                  € {{preparePriceDiscount(product.lastSalePrice, product.lastSaleDiscount)}}
                </div>
                <div v-if="!product.lastSalePrice" class="has-text-grey">-</div>
              </td>
              <td data-label="Note">
                {{product.notes}}
              </td>
              <td data-label="Disponibili">
                {{product.available}}
              </td>
              <td data-label="Ordinati">
                {{product.incoming}}
              </td>
              <td data-label="Usati">
                {{product.used}}
              </td>
              <td class="is-actions-cell is-justify-content-flex-end">
                <div class="buttons is-right">
                  <button v-if="!product.archived" class="button is-secondary" @click="archive(product, true)" title="Concludi" :class="[{'is-loading': product.waitArchive}]" :disabled="product.waitArchive">
                    <span class="icon"><font-awesome-icon icon="lock" /></span>
                  </button>
                  <button v-if="product.archived" class="button is-secondary" @click="archive(product, false)" title="Ripristina" :class="[{'is-loading': product.waitArchive}]" :disabled="product.waitArchive">
                    <span class="icon"><font-awesome-icon icon="lock-open" /></span>
                  </button>
                  <router-link :to="'/magazzino/' + product._id" class="button is-warning" type="button" title="Modifica" :disabled="product.waitDelete">
                    <span class="icon"><font-awesome-icon icon="pen" /></span>
                  </router-link>
                  <button class="button is-info" type="button" @click="openHistory(product)" title="Storico vendite">
                    <span class="icon"><font-awesome-icon icon="clock-rotate-left" /></span>
                  </button>
                  <button class="button is-danger" type="button" @click="deleteProduct(product)" title="Elimina" :class="[{'is-loading': product.waitDelete}]" :disabled="product.waitDelete">
                    <span class="icon"><font-awesome-icon icon="trash-can" /></span>
                  </button>
                </div>
              </td>
            </tr>
            <tr v-if="products.length === 0">
              <td colspan="100" class="has-text-centered has-text-grey">
                <i>Nessun risultato</i>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <Pagination :pagination="pagination" @change="getProducts($event)" />
    </div>

    <router-link to="/magazzino/new" class="button is-floating is-primary is-hidden-desktop" title="Nuovo">
      <span class="icon">
        <font-awesome-icon icon="plus" />
      </span>
    </router-link>

    <Modal :title="'Storico vendite'" :openModal="historyModal" @close="closeHistory()">
      <div v-if="historyLoading" class="has-text-centered py-4">
        <small class="has-text-grey">Caricamento...</small>
      </div>
      <div v-else>
        <div class="notification is-info is-light" v-if="historyProduct">
          <strong>{{historyProduct.brand}} {{historyProduct.code}} {{historyProduct.name}}</strong>
        </div>
        <div class="table-wrapper has-mobile-cards">
          <table class="table is-fullwidth is-striped is-hoverable">
            <thead>
              <tr>
                <th>Data</th>
                <th>Tipo</th>
                <th>Quantità</th>
                <th>Prezzo applicato</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, rIndex) in historyRecords" :key="rIndex">
                <td data-label="Data">{{formatHistoryDate(row.date)}}</td>
                <td data-label="Tipo">{{formatHistoryType(row)}}</td>
                <td data-label="Quantità">{{row.quantity}}</td>
                <td data-label="Prezzo applicato">€ {{row.finalPrice?.toFixed ? row.finalPrice.toFixed(2) : preparePrice(row.finalPrice).toFixed(2)}}</td>
              </tr>
              <tr v-if="historyRecords.length === 0">
                <td colspan="100" class="has-text-centered has-text-grey">
                  <i>Nessuna vendita</i>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  props: {
    isSelection: {
      type: Boolean,
      default: false
    }
  },

  emits: ['selected'],

  data() {
    return {
      filters: this.$store.state.filters.product,

      products: [],

      pagination:{
        total: false,
        selected: false
      },

      loading: true,

      selectedProduct: null,

      historyModal: false,
      historyLoading: false,
      historyProduct: null,
      historyRecords: []
    }
  },

  methods: {
    resetFilters() {
      this.filters = {
        name: null,
        brand: null,
        code: null,
        supplier: null,
        notes: null,
        archived: {'label': 'No', value: false}
      }

      this.getProducts()
    },

    getProducts(args = {page: 1, size: 30, scroll: 0}) {
      const self = this
      
      this.loading = true

      this.$store.commit('setFilter', {name: 'product', value: this.filters})
      this.$store.commit('setPage', {name: 'product', value: {number: args.page, size: args.size}})

      const name = this.filters.name
      const brand = this.filters.brand
      const code = this.filters.code
      const supplier = this.filters.supplier
      const notes = this.filters.notes
      const archived = this.filters.archived ? this.filters.archived.value : null

      this.$http.get('/product', { params: {
        page: args.page,
        size: args.size,
        name,
        brand,
        code,
        supplier,
        notes,
        archived
      } }).then(response => {
        if (response && response.data) {
          this.products = response.data.records
          this.pagination = {
            total: response.data.totalRecords,
            pages: response.data.totalPages,
            selected: response.data.currentPage
          }

          if (args.scroll) {
            self.$nextTick(() => {
              window.scroll(0, args.scroll)
            })
          }
        }

        this.loading = false
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
        self.loading = false
      })
    },

    deleteProduct(product) {
      if (confirm('Eliminare?')) {
        const self = this
        product.waitDelete = true

        this.$http.delete('/product/' + product._id)
        .then(function (response) {
          self.getProducts({page: self.$store.state.pages.product.number, size: self.$store.state.pages.product.size})
        })
        .catch(function (error) {
          console.log(error)
          alert('Errore')
          product.waitDelete = false
        })
      }
    },

    archive(product, value) {
      const self = this
      product.waitArchive = true

      this.$http.put('/product/' + product._id, {archived: value})
      .then(function (response) {
        self.getProducts()
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
        product.waitArchive = false
      })
    },

    preparePrice(price) {
      const formattedPrice = price ? price?.replace('€', '')?.trim().replace(',', '.') : 0
      return parseFloat(formattedPrice)
    },

    preparePriceDiscount(price, discount) {
      const formattedPrice = this.preparePrice(price)
      return parseFloat(formattedPrice - (formattedPrice * discount / 100)).toFixed(2)
    },

    openHistory(product) {
      this.historyModal = true
      this.historyLoading = true
      this.historyProduct = product
      this.historyRecords = []

      this.$http.get('/product/' + product._id + '/history')
      .then(response => {
        this.historyRecords = response?.data || []
        this.historyLoading = false
      })
      .catch(error => {
        console.log(error)
        alert('Errore')
        this.historyLoading = false
      })
    },

    closeHistory() {
      this.historyModal = false
      this.historyProduct = null
      this.historyRecords = []
      this.historyLoading = false
    },

    formatHistoryDate(value) {
      if (!value) return '-'
      const date = new Date(value)
      if (isNaN(date.getTime())) return value
      return date.toDisplay ? date.toDisplay() : date.toLocaleDateString()
    },

    formatHistoryType(row) {
      if (row.type === 'operation') {
        const op = row.operation
        if (!op) return 'Appuntamento'
        const client = op.occupant ? [op.occupant.business_name, op.occupant.surname, op.occupant.name].filter(Boolean).join(' ') : ''
        const place = op.place ? [op.place.city, op.place.address].filter(Boolean).join(' ') : ''
        return ['Appuntamento', client, place].filter(Boolean).join(' - ')
      }

      if (row.direct) {
        const direct = [row.direct.business_name, row.direct.surname, row.direct.name].filter(Boolean).join(' ')
        return direct ? 'Diretto - ' + direct : 'Diretto'
      }

      return 'Diretto'
    }
  },

  mounted() {
    this.getProducts({page: this.$store.state.pages.product.number, size: this.$store.state.pages.product.size, scroll: this.$store.state.pages.product.scroll})
  },

  created() {
    this.onFilterInput = this.$debounce(() => this.getProducts(), 500)
  },

  beforeUnmount() {
    const scroll = window.top.scrollY
    let page = Object.assign({}, this.$store.state.pages.product)
    page.scroll = scroll
    this.$store.commit('setPage', {name: 'product', value: page})
  }
}
</script>